@if (entry.kind !== 'message') {
<div class="my-2 flex justify-center">
  <p
    class="!m-0 flex items-center justify-center gap-0.75 rounded-full border px-1.5 py-0.25 text-sm text-center"
    [class]="activityClasses"
  >
    <span
      aria-hidden="true"
      class="block h-1.5 w-1.5 shrink-0 bg-current mask-contain mask-center mask-no-repeat"
      [style.mask-image]="
        'url(/assets/images/icons/' + activityIcons[entry.kind] + '.svg)'
      "
    ></span>
    <span>
      {{
        activityKey()
          | translate
            : {
                name:
                  author?.username || ("DISCUSSION.DELETED_USER" | translate),
                rating: entry.rating
              }
      }}
      @if (!entry.dateUnknown) {<span class="whitespace-nowrap"
        >· {{ entry.createdAt | date: "HH:mm" }}</span
      >}
    </span>
  </p>
</div>
} @else {
<div class="flex items-end gap-1 my-1" [class.flex-row-reverse]="own">
  @if (!own) {<app-user-avatar
    [name]="author?.username || ''"
    [picture]="author?.picture"
    [size]="28"
    [online]="authorOnline"
  ></app-user-avatar
  >}
  <div
    class="min-w-0 max-w-[85%] tablet:max-w-[calc(100%_-_102px)]"
    [class.text-right]="own"
  >
    <app-discussion-reactions
      #reactions
      class="w-fit max-w-full"
      [class.ml-auto]="own"
      [targetKey]="entry._id"
      [participants]="participants"
      [userId]="userId"
      [enabled]="reactionEnabled"
      [ownMessage]="own"
      [concealed]="entry.spoiler && !revealed"
      [actionsEnabled]="!entry.deletedAt && !entry.moderatedAt && !deleting"
      (closed)="confirming = false"
    >
      <div
        class="relative flow-root text-left rounded-2xl px-1.5 py-[6px] border"
        [appDiscussionGesture]="
          !entry.deletedAt && !entry.moderatedAt && !deleting
        "
        (reactionHold)="reactions.show()"
        (reactionGem)="reactions.gem()"
        [class]="
          own
            ? 'bg-primary/10 border-primary/40 rounded-br-sm'
            : 'bg-whitepale dark:bg-black-dark-lighter border-transparent rounded-bl-sm'
        "
      >
        @if (entry.moderatedAt) {
        <span class="italic text-grey dark:text-lightGrey">{{
          "DISCUSSION.MODERATED" | translate
        }}</span>
        } @else if (entry.deletedAt) {<span
          class="italic text-grey dark:text-lightGrey"
          >{{ "DISCUSSION.DELETED" | translate }}</span
        >} @else if (entry.spoiler && !revealed) {
        <button
          type="button"
          class="relative min-w-[180px] w-full py-1 font-bold text-sm"
          (click)="revealed = true"
          [attr.aria-label]="'DISCUSSION.REVEAL' | translate"
        >
          <span
            class="absolute inset-0 blur-sm opacity-30 select-none pointer-events-none"
            aria-hidden="true"
            >•••••••••••••••••••••••••</span
          >
          <span class="relative">{{ "DISCUSSION.REVEAL" | translate }}</span>
        </button>
        } @else { @if (entry.spoiler) {<span
          class="block text-xs font-bold text-primary mb-1"
          >{{ "DISCUSSION.SPOILER" | translate }}</span
        >}
        <app-discussion-text
          [text]="entry.text || ''"
          (openWork)="openWork.emit($event)"
        ></app-discussion-text>
        }
        <time
          class="float-right inline-flex items-center gap-[3px] ml-1.5 mt-[6px] text-[10px] leading-[12px] text-grey dark:text-lightGrey"
          [attr.datetime]="entry.createdAt"
          >{{ entry.createdAt | date: "HH:mm" }} @if (own && seen) {<span
            role="img"
            [attr.aria-label]="'DISCUSSIONS.SEEN' | translate"
            [title]="'DISCUSSIONS.SEEN' | translate"
            class="block w-[14px] h-[14px] bg-current mask-[url(/assets/images/icons/double-check.svg)] mask-contain mask-no-repeat"
          ></span
          >}
        </time>
      </div>
      <div discussionActions class="text-left text-sm">
        @if (entry.text && !entry.deletedAt && !entry.moderatedAt &&
        (!entry.spoiler || revealed)) {
        <app-discussion-copy
          [text]="entry.text"
          (completed)="reactions.close()"
        ></app-discussion-copy>
        } @if (own && !entry.deletedAt && !entry.moderatedAt) {
        <button
          type="button"
          class="block w-full min-h-[44px] rounded-xl px-1.5 text-left hover:bg-primary/10 focus-visible:outline-primary"
          [class.font-bold]="confirming"
          [disabled]="deleting"
          (click)="removeMessage(reactions)"
        >
          {{
            (confirming ? "DISCUSSION.CONFIRM_DELETE" : "DISCUSSION.DELETE")
              | translate
          }}
        </button>
        @if (confirming) {
        <button
          type="button"
          class="block w-full min-h-[44px] rounded-xl px-1.5 text-left hover:bg-primary/10 focus-visible:outline-primary"
          (click)="confirming = false"
        >
          {{ "DISCUSSION.CANCEL" | translate }}
        </button>
        } } @if (!own && !entry.deletedAt && !entry.moderatedAt) {
        <button
          type="button"
          class="block w-full min-h-[44px] rounded-xl px-1.5 text-left hover:bg-primary/10 focus-visible:outline-primary"
          (click)="reactions.close(); report.emit(entry._id)"
        >
          {{ "DISCUSSION.REPORT" | translate }}
        </button>
        }
      </div>
    </app-discussion-reactions>
  </div>
</div>
}
